import { useState, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { motion, AnimatePresence } from "framer-motion";
import { ArrowRight } from "lucide-react";
import { Embers } from "@/components/site/Embers";

const IMG = "https://static.prod-images.emergentagent.com/jobs/55e8a073-484f-45a0-9ce0-724193ee87a9/images/";
const BG = IMG + "57f12d36b81074e7c92028ed57169c05a2784e9357f7cfca51140a26eab8dc0f.jpeg";

function Mandala() {
  return (
    <svg viewBox="0 0 400 400" className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 h-[120vh] w-[120vh] opacity-[0.08] animate-[spin_120s_linear_infinite]" aria-hidden>
      {[190, 160, 130, 100].map((r, i) => (
        <circle key={r} cx="200" cy="200" r={r} fill="none" stroke="#D4AF37" strokeWidth={i % 2 ? 0.6 : 1} strokeDasharray={i % 2 ? "2 6" : "14 4"} />
      ))}
      {Array.from({ length: 24 }, (_, i) => (
        <ellipse key={i} cx="200" cy="55" rx="7" ry="22" fill="none" stroke="#E06D3B" strokeWidth="0.7" transform={`rotate(${i * 15} 200 200)`} />
      ))}
    </svg>
  );
}

export default function PreLanding() {
  const [exiting, setExiting] = useState(false);
  const navigate = useNavigate();

  const handleEnter = useCallback(() => {
    setExiting(true);
    setTimeout(() => navigate("/home"), 1200);
  }, [navigate]);

  return (
    <AnimatePresence>
      <motion.div
        className="relative h-screen overflow-hidden bg-[#0B0907]"
        data-testid="pre-landing"
        animate={exiting ? { opacity: 0, scale: 1.05 } : { opacity: 1, scale: 1 }}
        transition={{ duration: 1.2, ease: [0.4, 0, 0.2, 1] }}
      >
        <div className="absolute inset-0">
          <motion.img
            src={BG}
            alt=""
            className="h-full w-full object-cover opacity-20 blur-[2px]"
            animate={exiting ? { scale: 1.15, opacity: 0 } : {}}
            transition={{ duration: 1.3, ease: "easeInOut" }}
          />
          <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_50%_50%,#5a1414_0%,#2a0d0a_35%,#0B0907_75%)] opacity-90" />
        </div>

        <Mandala />
        <Embers />

        <div className="relative z-10 flex flex-col items-center justify-center h-full px-6 text-center">
          <motion.p
            initial={{ opacity: 0, y: 20 }}
            animate={exiting ? { opacity: 0, y: -20 } : { opacity: 1, y: 0 }}
            transition={{ duration: exiting ? 0.5 : 1, delay: exiting ? 0 : 0.3 }}
            className="text-[10px] sm:text-[11px] uppercase tracking-[0.6em] sm:tracking-[0.8em] text-[#D4AF37]"
          >
            Ancient Origin
          </motion.p>

          <motion.h1
            initial={{ opacity: 0, y: 30 }}
            animate={exiting ? { opacity: 0, y: -30 } : { opacity: 1, y: 0 }}
            transition={{ duration: exiting ? 0.6 : 1, delay: exiting ? 0.05 : 0.6 }}
            className="font-display font-bold text-4xl sm:text-6xl lg:text-8xl leading-[0.95] tracking-tight max-w-5xl mt-8 drop-shadow-[0_6px_30px_rgba(0,0,0,0.9)]"
          >
            Experience culture and design{" "}
            <span className="italic font-medium gold-text">like never before.</span>
          </motion.h1>

          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={exiting ? { opacity: 0, y: -20 } : { opacity: 1, y: 0 }}
            transition={{ duration: exiting ? 0.4 : 0.8, delay: exiting ? 0.1 : 1.2 }}
            className="mt-12"
          >
            <button
              onClick={handleEnter}
              className="btn-glow group inline-flex items-center gap-3 rounded-full bg-[#D4AF37] px-10 py-4 text-sm font-semibold uppercase tracking-[0.2em] text-[#0B0907] hover:bg-[#F3E5AB] transition-colors"
              data-testid="enter-button"
            >
              Explore the tale
              <ArrowRight className="h-4 w-4 transition-transform group-hover:translate-x-1" />
            </button>
          </motion.div>

          <motion.p
            initial={{ opacity: 0 }}
            animate={exiting ? { opacity: 0 } : { opacity: 1 }}
            transition={{ duration: exiting ? 0.3 : 1, delay: exiting ? 0 : 2 }}
            className="absolute bottom-8 text-[10px] uppercase tracking-[0.5em] text-[#A89F91]/60"
          >
            Handwoven silk sarees from across India
          </motion.p>
        </div>
      </motion.div>
    </AnimatePresence>
  );
}
